import { AxiosResponse } from "axios";
import { ManufacturerRequest, VehicleFiltersRequest } from "@/main/models/request";
import { api } from "../base/api";
import { IManufacturerApi } from "../base/vehicle/manufacturerApi";
import { Result } from "../../models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

const baseRoute: string = "VehicleManufacturer";

export class ManufacturerApi extends IManufacturerApi {
	getVehicleManufacturer(request: ManufacturerRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}

	getVehicleManufacturerByFilters(request: VehicleFiltersRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domainbyfilters`, { params: request });
	}

	getManufacturerByGuidCountry(request: ManufacturerRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/getManufacturerByGuidCountry`, {
			params: request,
		});
	}
}
